export const COHORT3_CONSOLIDATION_BANNER = 'EOC-COHORT3-CONSOLIDATION-BANNER' as const;
export const BANNER_HEIGHT = 50;
